import { useEffect } from 'react';

// L'app occupa esattamente la parte di schermo visibile.
//
// Segnalato il 04/10/2026 con uno screenshot dall'iPhone: aprendo la tastiera
// il campo di scrittura finiva sopra l'orologio e sotto restava mezza pagina
// vuota. Su iOS la tastiera non accorcia la pagina: la fa scorrere verso l'alto
// (visualViewport.offsetTop) e riduce la parte visibile. L'altezza la seguivamo
// già, lo spostamento no, quindi l'app restava in cima mentre lo schermo
// guardava più in basso. Ora l'app è fissa e scende con la parte visibile.
export function misuraViewport(viewport = window.visualViewport, radice = document.documentElement) {
  if (viewport && viewport.scale !== 1) return;   // durante uno zoom non si tocca niente
  radice.style.setProperty('--app-height', `${viewport?.height || window.innerHeight}px`);
  radice.style.setProperty('--app-top', `${Math.max(0, viewport?.offsetTop || 0)}px`);
}

export default function useViewport() {
  useEffect(() => {
    const viewport = window.visualViewport;
    const update = () => misuraViewport(viewport);
    update();
    viewport?.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      viewport?.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
}
